import { render, staticRenderFns } from "./m-chain-perf.vue?vue&type=template&id=2050bfe5&scoped=true&"
import script from "./m-chain-perf.vue?vue&type=script&lang=ts&"
export * from "./m-chain-perf.vue?vue&type=script&lang=ts&"
import style0 from "./m-chain-perf.vue?vue&type=style&index=0&id=2050bfe5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2050bfe5",
  null
  
)

export default component.exports